import { Button, FormControl, InputLabel, makeStyles, MenuItem, Select, Typography } from "@material-ui/core";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import React, { useEffect, useState, useReducer } from "react";
import { getCookieValue } from "../../../cookieHelper";
import translate from "../../../i18n/translate";
import "./CultureNotesTopic.scss";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import { useHistory } from "react-router-dom";
import Axios from "axios";
import Loader from "../../shared/Loader/Loader";
import { useSelector } from "react-redux";
import { cultureNotesTopicDD } from "../../../globalConstants";

const CultureNotesTopic: React.FC = () => {

    const useStyles = makeStyles((theme) => ({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 450,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
    }));

    const [cultureNotesTopicFeatureEnabled, setCultureNotesTopicFeatureEnabled] = useState(true);
    const [cultureNotesTopicErrorEnabled, setCultureNotesTopicErrorEnabled] = useState(false);
    const allInfo = useSelector((state: any) => state);
    const categoryLists = cultureNotesTopicDD[0].CategoryList;
    const categoryMaps = cultureNotesTopicDD[0].CategoryMap;
    const classes = useStyles();
    const [categories] = useState(categoryLists);
    let [categoryMap, setCategaryMap] = useState<any>([]);
    const [text, setText] = useState("");
    const [title, setTitle] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [content, setContent] = useState([]);
    const history = useHistory();
    const [loaderFlag, setLoaderFlag] = useState(false);

    const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
        toastOpen: false,
        toastSeverity: "error",
        toastMessageKey: "",
      });
    
      const handleToastOptionsDirect = (name: string, val: any) => {
        settoastOptions({ [name]: val });
      }
    
      const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
        handleToastOptionsDirect("toastSeverity", severity);
        handleToastOptionsDirect("toastMessageKey", messageKey);
        handleToastOptionsDirect("toastOpen", !!open);
      };

    useEffect(() => {
        if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
            if ((allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28)) === "1") {
                setCultureNotesTopicFeatureEnabled(true);
                setCultureNotesTopicErrorEnabled(false);
              }
              else{
                setCultureNotesTopicFeatureEnabled(true);
                setCultureNotesTopicErrorEnabled(false);
              }
        }
      }, [allInfo.peopleInformation]);

      async function fetchData(lang: string) {
        const data= await Axios.get( `${process.env.REACT_APP_BLOB_STORAGE}/culturenotestopic/CultureNotes.${lang}.json`)
          .then(  (response) => {
              setLoaderFlag(false);
              return response.data;
            }) .catch((err: any) => {
              setLoaderFlag(false);
              toasterHandle(true, "error", "message_errorDefault");
              RollbarErrorTracking.logErrorInRollbar(err.message, "error");
            });;
            return data;
      }

    const readFile = async (translationUpdate: boolean) => {
        const lang : string = getCookieValue("ulang") || "EN";
        const data: any = !translationUpdate  ? content : await fetchData(lang);
        setContent(data);
        const arrayIndex: string = localStorage.getItem("categoryMapSelected") + "Bdy";
        const titile1Index: string = localStorage.getItem("categorySelected") || "";
        const title1: string = data[titile1Index];
        const title2 = data[localStorage.getItem("categoryMapSelected") + "Btitle"];
        setText(data[arrayIndex]);
        setTitle(title1 + ": " + title2);
    };

    const gotoNextPage = () => {
        const nextPage: number = currentPage + 1;
        if (nextPage <= totalCount)
            setCurrentPage(nextPage);
        handleChangeValue("", "next");
    }
    const gotoPreviousPage = () => {
        const prevPage: number = currentPage - 1;
        if (prevPage > 0) {
            setCurrentPage(prevPage);
            handleChangeValue("", "previous");
        }
    }

    useEffect(() => {
        setLoaderFlag(true);
        localStorage.setItem("categorySelected", categories[0]);
        let categoryMap = categoryMaps.filter(data =>
            data.Name === (categories[0])
        );
        localStorage.setItem("categoryMapSelected", categoryMap[0].Topics[0]);
        setTotalCount(categoryMap[0].Topics.length);
        setCurrentPage(1);
        readFile(true);
    }, []);

    useEffect(() => {
         readFile(true);
    }, [getCookieValue("ulang")]);

    function handleChange(event: any) {
        let categoryMap = categoryMaps.filter(data =>
            data.Name === (event.target.value)
        );
        localStorage.setItem("categorySelected", event.target.value);
        setCategaryMap(categoryMap[0].Topics);
        localStorage.setItem("categoryMapSelected", categoryMap[0].Topics[0]);
        readFile(false);
        setTotalCount(categoryMap[0].Topics.length);
        setCurrentPage(1);
    }

    const handleChangeValue = (event: any, eventType: string) => {
        let setValue: string = "";
        let nextIndex: number = 0;
        if (eventType === "next") {
            const selectedDD: number = Number(localStorage.getItem("categoryMapSelected")?.slice(-1));
            nextIndex = selectedDD + 1;
            setValue = localStorage.getItem("categorySelected") + "n" + String(nextIndex);
        }
        else if (eventType === "previous") {
            const selectedDD: number = Number(localStorage.getItem("categoryMapSelected")?.slice(-1));
            nextIndex = selectedDD - 1;
            setValue = localStorage.getItem("categorySelected") + "n" + String(nextIndex);
        }
        else {
            setValue = event.target.value;
            nextIndex = Number(event.target.value.slice(-1));
        }
        localStorage.setItem("categoryMapSelected", setValue);
        readFile(false);
        setCurrentPage(nextIndex);
    };

    const redirecttocultureNotes = () => {
        history.push("/culturenotes");
    }

    useEffect(() => {
        if (localStorage.getItem("categorySelected")) {
            if (localStorage.getItem("categorySelected")) {
                let categoryMap = categoryMaps.filter(data =>
                    data.Name === (localStorage.getItem("categorySelected"))
                );
                setCategaryMap(categoryMap[0].Topics);
            }
        }
    }, [localStorage.getItem("categorySelected")]);

    return (
        <span className="cultureNotes-topicContainer"> 
        {cultureNotesTopicFeatureEnabled && 
        <div className="cultureNotes_topicContainer">
            <div className="cultureTopic_child_header">
                <div className="CN_Topic_Title">
                    <h3 className="cultureLocation_header_text" onClick={redirecttocultureNotes}>
                        {translate("feature_cultureNotes_title")}
                    </h3>
                </div>
            </div>
            <div className="ddbodyWrapper">
                <div className="childWrapper">
                    <div className="categoryDD">
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="demo-simple-select-outlined-label-category">{translate("SelectACategory")}</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label-category"
                                id="Continent"
                                value={localStorage.getItem("categorySelected") || ""}
                                onChange={handleChange}
                                label={translate("SelectACategory")}
                            >
                                {categories.map((option: any, index: number) => {
                                    return (
                                        <MenuItem value={option}>
                                            {content[option]}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="categoryDD">
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="demo-simple-select-outlined-label-topic">{translate("SAT")}</InputLabel>
                            <Select
                                labelId="demo-simple-select-outlined-label-topic"
                                id="Countries"
                                value={localStorage.getItem("categoryMapSelected") || ""}
                                onChange={(event) => handleChangeValue(event, "")}
                                label={translate("SAT")}
                            >
                                {categoryMap.map((option: any, index: number) => {
                                    return (
                                        <MenuItem value={option}>
                                            {content[option]}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </div>
            <div className="contentTopic_Container">
                <div className="titleSection"> <b><span dangerouslySetInnerHTML={{ __html: title }} /></b></div>
                <div className="textSection"> <span dangerouslySetInnerHTML={{ __html: text }} /></div> 
            </div>
            <div className="pagenationWrapper">
                    <div className="CNTopicPagination">
                        <span className="pageNationText">{currentPage}/{totalCount}</span>
                        <span className="arrowTopicbtn">
                            <ArrowBackIosIcon aria-disabled={currentPage > 0 ? false : true} onClick={gotoPreviousPage} className="backArrow"></ArrowBackIosIcon>
                        </span>
                        <Button onClick={gotoNextPage} disabled={currentPage !== totalCount ? false : true} type="button" variant="contained" color="primary" >
                            <Typography>{translate("button_next")}</Typography>
                        </Button>
                    </div>
                </div>
                <Loader showLoader={loaderFlag} /> 
        </div>
        }
         {cultureNotesTopicErrorEnabled && (
            <div className="culture-Notes-Topic-Errorpage">
            <ErrorPage status={401} />
            </div>
        )}   
   </span>
   );
}

export default CultureNotesTopic;